import { render, staticRenderFns } from "./ExhibitorLogoCard.vue?vue&type=template&id=d2a2be92&"
import script from "./ExhibitorLogoCard.vue?vue&type=script&lang=ts&"
export * from "./ExhibitorLogoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports